import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Logotipo } from './Logotipo'

/**
 * Marco de las pantallas de acceso: fondo acero, columna centrada estrecha,
 * logotipo arriba y un `.panel` con el formulario.
 *
 * Las seis pantallas (entrar, registro, verificar, recuperar, restablecer, sin
 * acceso) comparten exactamente esta caja. Tenerla en un componente es lo que
 * garantiza que sigan pareciéndose entre sí cuando se toque una.
 */
export function MarcoAcceso({
  children,
  pie,
  ancho = 'max-w-[380px]',
}: {
  children: ReactNode
  /** Enlace de escape al pie, fuera del panel. */
  pie?: ReactNode
  ancho?: string
}) {
  return (
    <div className="min-h-screen grid place-items-center bg-acero-100 px-4 py-8">
      <div className={`w-full ${ancho}`}>
        {/*
          Versión VERTICAL: es la principal del manual, y acá el espacio es más
          alto que ancho —una columna estrecha centrada—, que es exactamente el
          criterio con el que el manual manda elegir entre vertical y horizontal.
        */}
        <Link to="/" className="flex justify-center mb-5">
          <Logotipo variante="vertical" />
        </Link>

        <section className="panel p-5">{children}</section>

        {pie && <p className="text-center mt-3">{pie}</p>}
      </div>
    </div>
  )
}
